import request from '@/utils/request';


/*
*    文章列表
*    "lang": "zh",
*    "category": "news", // 可选
*    "news_type": "", // 可选
*    "is_hot": false, // 可选
*    "page": 1,
*    "page_size": 2
*/
export function ArticleListAPI (data) {
  return request({
    url: 'api/article/list',
    method: 'POST',
     data: {
      ...data,
      lang: localStorage.getItem("language") || "zh"
    }
  });
}

/*
*    文章详情
*/
export function ArticleDetailAPI (data) {
  return request({
    url: 'api/article/detail',
    method: 'POST',
    data: {
      ...data,
      lang: localStorage.getItem("language") || "zh"
    }
  });
}

/*
* 配置
*/
export function ConfigGetAPI (data) {
  return request({
    url: 'api/config/get',
    method: 'POST',
    data: {
      ...data,
      lang: localStorage.getItem("language") || "zh"
    }
  });
}

/*
*  菜单列表
*/
export function MenuListAPI (data) {
  return request({
    url: 'api/menu/list',
    method: 'POST',
    data: {
      ...data,
      lang: localStorage.getItem("language") || "zh"
    }
  });
}

/*
*  资料包列表
*/
export function AssetListAPI (data) {
  return request({
    url: 'api/media/asset/list-all',
    method: 'POST',
    data: {
      ...data,
      lang: localStorage.getItem("language") || "zh"
    }
  });
}

/*
*  banner列表
*/
export function BannerListAPI (data) {
  return request({
    url: 'api/media/image/list',
    method: 'POST',
    data
    // : {
    //   ...data,
    //   lang: localStorage.getItem("language") || "zh"
    // }
  });
}

/*
*  提交参展商申请
*/
export function ExhibitorSubmitAPI (data) {
  return request({
    url: 'api/exhibitor/application/submit',
    method: 'POST',
    data
  });
}

/*
*  提交媒体注册
*/
export function MediaSubmitAPI (data) {
  return request({
    url: 'api/media/cooperation/submit',
    method: 'POST',
    data
  });
}






